import { render, staticRenderFns } from "./ThemeCalendar.vue?vue&type=template&id=80c96506"
import script from "./ThemeCalendar.vue?vue&type=script&lang=js"
export * from "./ThemeCalendar.vue?vue&type=script&lang=js"
import style0 from "./ThemeCalendar.vue?vue&type=style&index=0&id=80c96506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports